import {AppDispatch} from 'src/redux/store'
import {fetchUserAccountDetailsAsync} from 'src/redux/actions/accountActions'
import {finalizeTikTokInstallationIfNeeded, hasPendingPlatformInstallation} from './tiktokFinalizer'

export const finalizeTikTokAfterAuth = async (dispatch: AppDispatch) => {
  if (!hasPendingPlatformInstallation()) {
    return false
  }

  try {
    const userResponse = await dispatch(fetchUserAccountDetailsAsync())
    const authenticatedUser = userResponse?.payload

    if (!authenticatedUser) {
      return false
    }

    await finalizeTikTokInstallationIfNeeded(dispatch, authenticatedUser)
    return true
  } catch (error) {
    console.error('finalizeTikTokAfterAuth failed', error)
    return false
  }
}
